<template>
        <v-text-field 
            v-bind="$attrs"
            @keyup.enter="emit('keyup-enter', $event)"
            :type="type"
            :hide-details="hideDetails" 
            :autofocus="autofocus"  
            :prepend-inner-icon="prependInnerIcon"
            :append-icon="appendIcon"
            :error-messages="errorMessages" 
            v-model="model" 
            :label="label"
            :outlined="outlined"
            :dense="dense"
            :solo="solo"
            :disabled="disabled || (code && (!user && !user.is_master) && (!user && !user.is_internal))"
            :readonly="readonly || (code && (!user && !user.is_master) && (!user && !user.is_internal))"
            :placeholder="placeholder"
            class="custom-placeholder"
            :flat="flat"
            :solo-inverted="soloInverted"
            :clearable="clearable"
            :dark="dark"
            :loading="loading"
            :rules="rules"
        >

            <template v-slot:append>
                <slot name="append" />
                <emc-info-help 
                    v-if="code || textHelper"
                    :icon-color="code ? 'error' : 'indigo'" 
                    title="Informações" 
                    :text="textHelper ? textHelper : 'Código externo utilizado para integração com outros sistemas. É permitido alteração apenas pelo administrador.'" 
                    />
            </template>

            <template v-slot:prepend-inner>
                <slot name="prepend-inner"></slot>
            </template>

            <template v-slot:append-outer>
                <slot name="append-outer"></slot>
            </template>

        </v-text-field>
</template>


<script setup>

import { useStore } from '@/composables/useStore'

import { computed, defineEmits, defineProps } from 'vue'

const props = defineProps({
    type:           { type: String, default: "text" },
    value:          { type: [String, Number] },
    autofocus:      { type: Boolean, default: false },
    label:          { type: String, required: false },
    errorMessages:  { type: Array, required: false },
    code:           { type: Boolean, default: false },
    textHelper:     { type: String, required: false },
    readonly:       { type: Boolean, required: false },
    disabled:       { type: Boolean, required: false },
    outlined:       { type: Boolean, default: false },
    prependInnerIcon: { type: String, required: false },
    appendIcon: { type: String, required: false },
    solo: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    placeholder: { type: String, required: false},
    flat: { type: Boolean, default: false },
    soloInverted: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    rules: { type: Array, required: false }
})

const emit = defineEmits(['input', 'keyup-enter'])

const model = computed({
    get() {
        return props.value
    },
    set(val) {
        emit('input', val)
    }
})

const hideDetails = computed(() => {
    if(props.errorMessages === undefined) {
        return true
    }
    return Object.keys(props.errorMessages).length ? false : true
})

// Acessar a store manualmente no Vue 2 com Composition API
const store = useStore()

const user = computed(() => store.state.auth.user)

</script>